module.exports = __webpack_public_path__ + "static/media/penganggaran.cbafc26e.png";